module.exports = __webpack_public_path__ + "media/images/icon__point--default-469fbae2f1982a25f0ceb76de1ba6cc0.png";